module.exports = __webpack_public_path__ + "static/blue_brush_1-a9a03f9e335b9603622ffecc81bf610b.png";